<template>
  <div class="app-body-1160px transparent">
    <!-- 标题 -->
    <ModuleHeader title="BLT翻译组" detail="起源于2018年的插件翻译开源项目"
                  url="/article/de2a294a-2175-11eb-8436-0242ac110002"></ModuleHeader>
    <!-- 主体 -->
    <div id="app-blt-body">
      <!-- 左边 -->
      <div id="app-blt-left">
        <ul>
          <li v-for="item in 3" :key="item.id">
            <el-card class="app-blt-card">
              敬请期待
            </el-card>
          </li>
        </ul>
      </div>
      <!-- 轮播图 -->
      <div id="app-blt-carousel">
        <el-carousel :interval="4000" trigger="click" arrow="always" height="325px">
          <el-carousel-item v-for="item in imgList" :key="item.id">
            <img :src='item.url' class="main-body-carousel-img" alt="pic"/>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleHeader from "@/views/share/home/ModuleHeader";

export default {
  name: "BLTranslate",
  components: {
    ModuleHeader
  },
  data() {
    return {
      imgList: [
        {
          url: 'https://img.blendermagic.cn/new/blt/bltCarousel1.jpg',
        },
        {
          url: 'https://img.blendermagic.cn/new/blt/bltCarousel2.jpg',
        },
        {
          url: 'https://img.blendermagic.cn/new/blt/bltCarousel3.jpg',
        }
      ]
    }
  }
}
</script>

<style scoped>

#app-blt-body {
  position: relative;
  height: 370px;
}

#app-blt-carousel {
  position: absolute;
  top: 0;
  left: 300px;
  right: 0;
  height: 300px;
}

.app-blt-card {
  width: 290px;
  height: 100px;
  line-height: 100px;
  margin-bottom: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #6d6d6d;
}

</style>